export enum RTS_COLUMN_NAME {
  PARCEL_CENTER_LOCATION_NAME = "parcelCenterLocationName",
  CLIENT_NAME = "shipmentClientName",
  PACKAGE_TRACKING_NUMBER = "trackingNumber",
  PACKAGE_STATUS = "status",
  STATUS_DATE = "statusDate",
  LAST_SCHEDULED_DELIVERY = "deliveryDate",
  RECIPIENT_CITY = "shipmentRecipientCity",
  RECIPIENT_STATE = "shipmentRecipientState",
  RECIPIENT_ZIP = "shipmentRecipientZip",
  UPDATED_ON = "updatedOn",
}

export enum RTS_LABEL_NAME {
  PARCEL_CENTER_LOCATION_NAME = "Parcel Center",
  CLIENT_NAME = "Client",
  PACKAGE_TRACKING_NUMBER = "Tracking Number",
  PACKAGE_STATUS = "Package Status",
  STATUS_DATE = "Status Date",
  LAST_SCHEDULED_DELIVERY = "Last Scheduled Delivery",
  RECIPIENT_CITY = "Recipient City",
  RECIPIENT_STATE = "Recipient State",
  RECIPIENT_ZIP = "Recipient Zip",
  UPDATED_ON = "Updated On",
}

export const RTS_FILTER_COLUMN_OPTIONS = [
  {
    label: RTS_LABEL_NAME.PARCEL_CENTER_LOCATION_NAME,
    value: RTS_COLUMN_NAME.PARCEL_CENTER_LOCATION_NAME,
  },
  {
    label: RTS_LABEL_NAME.CLIENT_NAME,
    value: RTS_COLUMN_NAME.CLIENT_NAME,
  },
  {
    label: RTS_LABEL_NAME.PACKAGE_STATUS,
    value: RTS_COLUMN_NAME.PACKAGE_STATUS,
  },
  {
    label: RTS_LABEL_NAME.STATUS_DATE,
    value: RTS_COLUMN_NAME.STATUS_DATE,
  },
  {
    label: RTS_LABEL_NAME.LAST_SCHEDULED_DELIVERY,
    value: RTS_COLUMN_NAME.LAST_SCHEDULED_DELIVERY,
  },
  {
    label: RTS_LABEL_NAME.RECIPIENT_CITY,
    value: RTS_COLUMN_NAME.RECIPIENT_CITY,
  },
  {
    label: RTS_LABEL_NAME.RECIPIENT_STATE,
    value: RTS_COLUMN_NAME.RECIPIENT_STATE,
  },
  {
    label: RTS_LABEL_NAME.RECIPIENT_ZIP,
    value: RTS_COLUMN_NAME.RECIPIENT_ZIP,
  },
];
